import apiClient from './apiClient';

const payslipTemplateBuilderService = {
  /**
   * Get available fields for template builder
   */
  getAvailableFields: async () => {
    const response = await apiClient.get('/payslip-template-builder/fields');
    return response.data;
  },

  /**
   * Get all templates
   */
  getAll: async (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({
      page,
      limit,
      ...filters
    });
    const response = await apiClient.get(`/payslip-template-builder?${params}`);
    return response.data;
  },

  /**
   * Get template by ID
   */
  getById: async (id) => {
    const response = await apiClient.get(`/payslip-template-builder/${id}`);
    return response.data;
  },

  /**
   * Create new template
   */
  create: async (templateData) => {
    const response = await apiClient.post('/payslip-template-builder', templateData);
    return response.data;
  },

  /**
   * Update template
   */
  update: async (id, templateData) => {
    const response = await apiClient.put(`/payslip-template-builder/${id}`, templateData);
    return response.data;
  },

  /**
   * Delete template
   */
  delete: async (id) => {
    const response = await apiClient.delete(`/payslip-template-builder/${id}`);
    return response.data;
  },

  /**
   * Generate payslip preview
   */
  generatePayslipPreview: async (templateId, employeeId, month, year) => {
    const response = await apiClient.post('/payslip-template-builder/preview/generate', {
      templateId,
      employeeId,
      month,
      year
    });
    return response.data;
  }
};

export default payslipTemplateBuilderService;
